<!-- <div class="preloader" [hidden]='!display'>
  <div class="status">
      <div class="spinner-border avatar-sm text-primary m-2" role="status"></div>
  </div>
</div> -->


<!-- <div *ngIf="display" class="preloader-overlay">
  <img src="assets/images/logonew.png" class="loader-logo" />
</div> -->


<div class="preloader-overlay" *ngIf="display">

  <div class="loader-card">

    <div class="loader">

      <!-- Background glow -->
      <div class="glow"></div>

      <!-- Rotating rings -->
      <div class="ring"></div>
      <div class="ring ring-two"></div>

      <!-- Pulse ripples -->
      <div class="ripple"></div>
      <div class="ripple ripple-two"></div>

      <!-- Particles -->
      <span class="particle p1"></span>
      <span class="particle p2"></span>
      <span class="particle p3"></span>
      <span class="particle p4"></span>
      <span class="particle p5"></span>

      <!-- Heart -->
      <svg class="heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 104.74 103.63" aria-hidden="true">

        <g>

          <path class="fil0"
            d="M51.47 10.38c-1.25,3.48 -19.1,20.11 -23.52,24.06 -0.85,0.76 -1.58,1.55 -2.43,2.32 -2.54,2.32 -4.69,4.6 -6.96,7.32 -0.94,1.12 -3.6,3.93 -4.71,4.59 0.5,0.74 3.82,4.03 4.64,4.67l11.86 11.5c0.45,0.45 0.74,0.74 1.19,1.19 0.55,0.55 0.73,0.62 1.29,1.09 1.8,1.5 4.02,4.08 5.85,5.84 0.53,0.51 0.78,0.59 1.3,1.08l5.84 5.84c0.53,0.47 0.77,0.55 1.3,1.08 1.21,1.2 3.61,3.9 4.81,4.71 2.24,-1.18 1.5,-0.74 3.56,-2.28 1.67,-1.25 2.19,-1.98 3.21,-2.84 4.57,-3.82 11.97,-12.02 16.54,-16.56 5.66,-5.61 13.29,-12.44 17.94,-17.97 2.35,-2.8 4.48,-5.68 5.78,-9.37 5.41,-15.45 -4.02,-29.51 -16.52,-34.49 -8.13,-3.24 -16.97,-1.26 -24.06,2.99 -3.56,2.13 -5.5,4.35 -6.9,5.23z" />

          <path class="fil2"
            d="M51.47 10.38c-1.25,3.48 -19.1,20.11 -23.52,24.06 -0.85,0.76 -1.58,1.55 -2.43,2.32 -2.54,2.32 -4.69,4.61 -6.96,7.32 -0.94,1.12 -3.6,3.93 -4.71,4.59 0.03,0.04 35.55,35.3 38.08,36.99 7.98,-4.22 35.46,-32.77 41.26,-39.66 2.35,-2.8 4.48,-5.68 5.78,-9.37 5.41,-15.45 -4.02,-29.51 -16.52,-34.49 -8.13,-3.24 -16.97,-1.26 -24.06,2.99 -3.56,2.13 -5.5,4.35 -6.9,5.23z" />

          <path class="fil3"
            d="M13.85 48.68c1.11,-0.67 3.78,-3.47 4.71,-4.59 2.27,-2.72 4.43,-5 6.96,-7.32 0.85,-0.77 1.58,-1.56 2.43,-2.32 4.41,-3.95 22.26,-20.58 23.52,-24.06 -1.48,-1.06 -1.22,-1.56 -2.7,-2.69l-3.03 -2.6c-2.87,-2.19 -8.76,-4.94 -12.91,-5.09l-6.54 0c-2.05,0.12 -3.93,0.52 -6.86,1.7 -2.14,0.86 -5.21,2.66 -6.84,4.19l-1.85 1.83c-2.9,3.42 -3.72,4.27 -5.62,9.09 -2.48,6.28 -2.73,15.59 0.06,21.92 1.22,2.75 2.76,4.42 4.51,6.53l4.15 3.43z" />

          <path class="fil3"
            d="M62.53 98.88c0,2.06 0.95,2.87 1.94,4.76 1.77,-0.85 3.23,-0.54 6.44,-3.51 1.79,-1.66 2.87,-3.09 4.87,-5.09 0.88,-0.88 1.61,-1.6 2.49,-2.49 0.9,-0.91 1.67,-1.45 2.6,-2.38 5.67,-5.69 10.64,-10.2 16.12,-16.12l5.96 -6.59c3.27,-3.97 1.43,-4.6 -0.39,-7.31 -3.44,1.82 -2.06,0.71 -5.96,3.77 -0.49,0.38 -0.87,0.67 -1.33,1.05 -0.52,0.44 -0.8,0.84 -1.33,1.27 -0.59,0.47 -0.72,0.54 -1.28,1.1l-25.86 25.86c-1.08,1.08 -4.27,3.93 -4.27,5.68z" />

          <path class="fil4"
            d="M0 63.39c0,3.92 3.63,6.52 5.68,8.6l7.47 7.03c1.66,1.68 3.19,3.2 4.86,4.87l16.76 16.77c3.28,3.22 5.53,1.14 7.63,-0.28 -1.49,-6.38 -6.76,-8.87 -11.09,-13.79 -2.55,-2.9 -4.51,-4.76 -7.36,-7.57 -0.91,-0.89 -1.45,-1.67 -2.38,-2.6l-11.26 -11.02c-1.95,-1.63 -7.03,-7.26 -9.56,-4.5 -0.43,0.47 -0.76,1.67 -0.76,2.49z" />

          <path class="fil5"
            d="M90.23 49.35c-4.27,-2.56 -38.53,-38.31 -38.76,-38.97 1.48,-1.06 1.22,-1.56 2.7,-2.69l3.03 -2.6c2.87,-2.19 8.75,-4.94 12.92,-5.09l6.53 0c2.05,0.12 3.94,0.52 6.86,1.7 2.14,0.86 5.21,2.66 6.84,4.19l1.85 1.83c2.9,3.42 3.95,4.21 5.86,9.03 7.34,12.91 0.1,25.17 -7.82,32.6z" />

        </g>

      </svg>

      <!-- Moving reflection -->
      <div class="sweep"></div>

    </div>

    <!-- Loading dots -->
    <div class="loading-dots">
      <span></span>
      <span></span>
      <span></span>
    </div>

  </div>

</div>